import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import closeIcon from '../../images/icon-close.png';
import getCarrierIcon from '../../helpers/carrier';
import format from '../../helpers/format';
import PoliciesQuotesDispatch from '../../contexts/policiesQuotes.dispatch';
import policiesQuotesActions from '../../actions/policiesQuotes.actions';

import BindRequest from './BindRequest';
import style from './PolicyQuoteDetailsPanel.module.css';

const PolicieQuoteDetailsPanel = React.memo(({ id, clientId, policy }) => {
  const [policyQuote, setPolicyQuote] = useState({
    Coverages: [],
    GeneralInfo: {},
    Locations: [],
    PersonalProperties: [],
    Vehicles: [],
  });

  const [bindRequestDetails, setBbindRequestDetails] = useState({
    IsPolicy: true,
    IsBound: false,
    IsBindable: false,
  });
  const [bindRequest, setBindRequest] = useState(false);

  const policiesQuotesDispatch = useContext(PoliciesQuotesDispatch);

  useEffect(() => {
    document.querySelector('#top').scrollTop = 0;

    const handleSuccess = ({ data }) => {
      setPolicyQuote(data);
      setBbindRequestDetails({
        IsPolicy: data.GeneralInfo.IsPolicy,
        IsBound: data.GeneralInfo.IsBound,
        IsBindable: data.GeneralInfo.IsBindable,
      });
    };

    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/panels/${
          policy ? 'policies' : 'quotes'
        }/${id}/details`,
      )
      .then(handleSuccess);
  }, [id, policy]);

  const handleCloseViewDetails = event => {
    event.preventDefault();

    policiesQuotesDispatch({
      type: policiesQuotesActions.POLICIES_QUOTES_VIEW_DETAILS_REQUEST,
      id: null,
    });
  };

  const carrierIcon = getCarrierIcon(policyQuote.GeneralInfo.CarrierId);

  const handleBindRequestClick = () => {
    setBindRequest(true);
  };

  const handleCloseBindRequest = submitted => {
    setBindRequest(false);
    if (submitted) {
      setBbindRequestDetails({
        IsPolicy: false,
        IsBound: true,
        IsBindable: false,
      });
      policiesQuotesDispatch({
        type: policiesQuotesActions.POLICIES_QUOTES_BIND_REQUEST_SENT,
        bindRequestSent: true,
      });
    }
  };

  const showRequestBind = () => {
    if (!bindRequestDetails.IsPolicy) {
      if (bindRequestDetails.IsBound) {
        return <span>Bind request sent.</span>;
      }

      if (bindRequestDetails.IsBindable) {
        return (
          <button
            onClick={handleBindRequestClick}
            className={style.bindBtn}
            type="button"
          >
            Request Bind
          </button>
        );
      }
    }

    return null;
  };

  return (
    <>
      <section className={style.main}>
        <div className={style.header}>
          <span className={style.title}>
            {policy ? 'POLICY DETAILS' : 'QUOTE DETAILS'}
          </span>
          <button
            className={style.closeBtn}
            type="button"
            onClick={handleCloseViewDetails}
          >
            <img alt="close" src={closeIcon} />
          </button>
        </div>
        <div className={style.info}>
          <span className={style.lob}>
            {policyQuote.GeneralInfo.LobDescription}
          </span>
          <div className={style.carrier}>
            {carrierIcon && <img src={carrierIcon} alt="carrier" />}
            <span className={style.name}>
              {policyQuote.GeneralInfo.CarrierName}
            </span>
          </div>
          <div className={style.premium}>
            <span className={style.rating}>
              Rating: <span>{policyQuote.GeneralInfo.Rating}</span>
            </span>
            <span className={style.amount}>
              {policyQuote.GeneralInfo.Premium}
            </span>
          </div>
          <div className={style.policyId}>
            {policy ? 'POLICY ID #' : 'QUOTE ID #'}
            {policyQuote.GeneralInfo.Id}
            {showRequestBind()}
          </div>
          <ul className={style.converages}>
            {policyQuote.Coverages.map((item, idx) => {
              return (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={idx}
                  className={`${style.item} ${idx % 2 === 0 ? style.even : ''}`}
                >
                  <span className={style.label}>{item.Description}</span>
                  <span className={style.value}>
                    {format.formatCoverage(item.ValueType, item.Value)}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
      <BindRequest
        opened={bindRequest}
        onClose={submitted => handleCloseBindRequest(submitted)}
        lob={policyQuote.GeneralInfo.LobDescription}
        carrier={policyQuote.GeneralInfo.CarrierName}
        premium={policyQuote.GeneralInfo.Premium}
        quoteId={id}
        clientId={clientId}
        busName={policyQuote.GeneralInfo.ClientBusinessName}
      />
    </>
  );
});

PolicieQuoteDetailsPanel.propTypes = {
  id: PropTypes.string.isRequired,
  policy: PropTypes.bool.isRequired,
};

export default PolicieQuoteDetailsPanel;
